<template>
	<div class="body">
		<div class="cont_title">
			<div>选择模板</div>
			<div class="rightBox">
				<p class="returnBtn" style="margin-right: 30px" @click="jump('chongzhi')">充值</p>
				<p class="returnBtn" @click="jump('duanxin')">返回</p>
			</div>
		</div>
		<div style="clear: both;width: 100%;height: 11px"></div>
		<div class="shezhitix">
			<el-radio-group v-model="radio">
			    <el-radio v-for="(item,index) in temp_data" :key="index" v-if="item.mb_type !== '放假通知'" :label="item.mb_id"   @change="xuan(index)" style="margin-left: 0;">{{item.mb_type}} {{item.mb_contont}}</el-radio>
				<el-radio v-for="(item,indexa) in temp_data" :key="indexa" v-if="item.mb_type == '放假通知'" :label="item.mb_id"  @change="xuan(indexa)" style="margin-left: 0;">
			    	{{item.mb_type}} 亲爱的会员家长您好，
			    	<el-date-picker
				      v-model="start_time"
				      type="date"
				      size="mini"
				      style="width: 130px;"
				      value-format="MM-dd"
				      placeholder="开始时间">
				    </el-date-picker> —
				    <el-date-picker
				      v-model="e_time"
				      type="date"
				      size="mini"
				      style="width: 130px;"
				      value-format="MM-dd"
				      placeholder="结束时间">
				    </el-date-picker>
				       为法定假日，本中心进行调课，
				    <el-date-picker
				      v-model="end_time"
				      type="date"
				      size="mini"
				      style="width: 130px;"
				      value-format="MM-dd"
				      placeholder="选择日期">
				    </el-date-picker>
				     正式上课，给您带来的不便敬请谅解！
			    </el-radio>
			</el-radio-group>
		</div>
		<div class="cont_title fasong">选择学员</div>

		<div class="tableSearch">
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item label="生日月份：" class="yuefen">
					<el-select v-model="birthday" placeholder="请选择" size="small">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<!--<el-form-item label="项目类别：" class="yuefen">-->
					<!--<el-select v-model="xm_id" placeholder="请选择" size="small">-->
						<!--<el-option v-for="item in xiangmu" :key="item.value" :label="item.name" :value="item.id">-->
						<!--</el-option>-->
					<!--</el-select>-->
				<!--</el-form-item>-->

				<el-form-item label="月龄">
					<el-row style="width: 200px">
						<el-col :span="11">
							<el-input-number v-model="yuel1" controls-position="right" :min="0" size="small" style="width: 100%"></el-input-number>
						</el-col>
						<el-col class="line" :span="2" style="text-align: center">-</el-col>
						<el-col :span="11">
							<el-input-number v-model="yuel2" controls-position="right" :min="0" size="small" style="width: 100%"></el-input-number>
						</el-col>
					</el-row>

				</el-form-item>

				<el-form-item label="类型">
					<el-row style="width: 100px">
						<el-col :span="24">
							<el-select v-model="value2" placeholder="请选择" style="width: 100%" size="small">
								<el-option v-for="item in options2" :key="item.value2" :label="item.label2" :value="item.value2">
								</el-option>
							</el-select>
						</el-col>
					</el-row>
				</el-form-item>

			</el-form>

			<el-row style="width: 180px;padding-top: 5px">
				<el-col :span="24">
					<el-input placeholder="请输入内容" v-model="input5" class="input-with-select" size="small">
						<el-button @click="SEO" slot="append" type="warning" size="small" style="background:#E6BE8A;color: #fff " icon="el-icon-search"></el-button>
					</el-input>
				</el-col>
			</el-row>
		</div>

		<el-table ref="multipleTable" v-loading="loading" :data="database" height="50vh" stripe border @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column label="姓名">
				<template slot-scope="scope">{{ scope.row.baobao_name }}</template>
			</el-table-column>
			<el-table-column prop="baobao_birthday" label="生日">
			</el-table-column>
			<el-table-column prop="yueling" label="月龄">
			</el-table-column>
			<el-table-column label="电话">
                <template slot-scope="scope">{{scope.row.guanxi}}-{{ scope.row.phone }}</template>
			</el-table-column>
			<el-table-column prop="vip" label="状态">
			</el-table-column>
		</el-table>

		<p class="tableTji" style="width: 100%;">
			<span>已选择【<span class="mobanType">{{rname}}</span>】模板 <span class="xuanzeshu">{{person_number}} 位学员</span></span>
			<button @click="confirm_send" class="qunfa">确认发送</button>
		</p>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:'',
				start_time:'',//放假时间
				e_time:'',//放假结束时间
				end_time:'',//开课时间
				loading:true,
				input5: '',
				radio:1,
				rname:'',
				radio_name:'',
				yue: '',
				birthday: '',
				value2: 1,
				yuel1: '',
				yuel2: '',
				options: [
				    {
						value: 1,
						label: '一月'
					},
					{
						value: 2,
						label: '二月'
					},
					{
						value: 3,
						label: '三月'
					},
					{
						value: 4,
						label: '四月'
					},
					{
						value: 5,
						label: '五月'
					},
					{
						value: 6,
						label: '六月'
					},
					{
						value: 7,
						label: '七月'
					},
					{
						value: 8,
						label: '八月'
					},
					{
						value: 9,
						label: '九月'
					},
					{
						value: 10,
						label: '十月'
					},
					{
						value: 11,
						label: '十一月'
					},
					{
						value: 12,
						label: '十二月'
					}
				],
				options2: [
				    {
						value2: 1,
						label2: '会员'
					},
					{
						value2: 2,
						label2: '非会员'
					}
				],
				database: [],//数据
				multipleSelection: [],
				arr:[],
				person_number:0,
				temp_data:[],
				xiangmu:'',//项目
				xm_id:1
			};
		},
		created(){
			this.token = this.$cookies.get('token');
			this.get_temp()
			this.get_list()
			this.get_xiang()
		},
		methods: {
			// 项目类别
			get_xiang(){
				let that=this
				$.ajax({
				   url: process.env.apiUrl + 'saas/biao/item_type',
				   type: 'post',
				   data:{
				  	  token:that.token
				    },
				    success: function (data) {
				        if(data.status == 1){
				        	that.xiangmu=data.data
				        }
					},
				})
			},
			//模板数据
			get_temp(){
				let that=this
				$.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxmbs',
				   type: 'post',
				   data:{
				  	  token:that.token
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				        	that.temp_data=data.data
							that.rname=that.temp_data[0].mb_type
				        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				})
			},
			get_list(){
				let that=this
				$.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxuser',
				   type: 'post',
				   data:{
				  	  token:that.token
				    },
				    success: function (data, status) {
				        if(data.status == 1){
							that.loading=false
				        	that.database=data.data
				        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				})
			},
			// 选择
		    xuan(i){this.rname=this.temp_data[i].mb_type},
			SEO(){
				let that=this
				$.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxuser',
				   type: 'post',
				   data:{
				  	  token:that.token,
				  	  stab:that.birthday,
				  	  yueling1:that.yuel1,
				  	  yueling2:that.yuel2,
				  	  type:that.value2,
				  	  name:that.input5,
					  item_id:that.xm_id
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				           that.database=data.data
				        }else if(data.status == 2){
                            that.database= ''
				            that.$message.error({
				           	  message:'暂无数据'
				            })
				        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				 })
			},
			//确定发送
			confirm_send(){
				let that=this
				$.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxfsdx',
				   type: 'post',
				   data:{
				  	  token:that.token,
				  	  mb_id:that.radio,
				  	  stime_start:that.start_time,
				  	  stime_end:that.e_time,
				  	  wtime:that.end_time,
				  	  arr:that.arr
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				        	that.$message({
				        		message:'发送成功',
				        		type:'success'
				        	})

				        }
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				 })
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if(rowIndex === 1) {
					return 'warning-row';
				} else if(rowIndex === 3) {
					return 'success-row';
				}
				return '';
			},
			jump: function(d) {
				this.$router.push(d)
			},
			handleSelectionChange: function(val) {
				this.person_number = val.length;

				this.arr=[]
				for(let i=0;i<val.length;i++){
					this.arr.push({id:val[i].user_id,phone:val[i].phone})
				}
			}
		},

	}
</script>

<style scoped>
	.body {
		padding-left: 45px;
		padding-right: 45px;
	}

	ul {
		list-style: none;
	}

	.cont_title {
		padding-left: 7px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		border-left: 6px solid #E6BE8A;
		margin-top: 14px;
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
	}

	.rightBox {
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
	}

	.returnBtn {
		width: 81px;
		height: 24px;
		line-height: 24px;
		color: #fff;
		background: #E6BE8A;
		border-radius: 12px;
		text-align: center;
		cursor: pointer;
		font-size: 12px;
	}

	.shezhitix {
		height: 150px;
		overflow-y: scroll;
		border: 1px solid #dbdbdb;
		padding-left: 25px;
		padding-right: 25px;
		padding-top: 10px;
		padding-bottom: 10px;
	}

	.shezhitix .el-radio {
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.shezhitix .el-radio {
		white-space: normal;
		line-height: 25px;
	}

	.fasong {
		border-left: 6px solid #fdb06a;
		margin-top: 59px;
	}

	.tableSearch {
		display: flex;
		display: -webkit-flex;
		justify-content: flex-end;
	}

	.tableTji {
		margin-top: 10px;
	}

	.tableTji span {
		color: #E6BE8A;
	}

	.qunfa {
		float: right;
		width: 134px;
		height: 38px;
		line-height: 38px;
		border: none;
		color: #fff;
		border-radius: 19px;
		background: #fcb06a;
	}

	.el-table .warning-row {
		background: #f0f9eb;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}
</style>
<style>
	.shezhitix .el-radio__input.is-checked+.el-radio__label {
		color: #E6BE8A;
	}

	.shezhitix .el-radio__input.is-checked .el-radio__inner {
		border-color: #E6BE8A;
		background: #E6BE8A;
	}

	.yuefen .el-select-dropdown {
		min-width: 80px;
	}

	.yuefen .el-input {
		width: 100px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/duanxin/duanxinfasong.vue